import AppState from "store/AppState";

export const selectSyncCategoriesLoading = (state: AppState) =>
  state.syncCategories.loading;

export const selectSyncCategoriesJobId = (state: AppState) =>
  state.syncCategories.syncJobId;

export const selectSyncCategoriesJobDetails = (state: AppState) =>
  state.syncCategories.syncJobDetails;

export const selectCategoryLatestSync = (state: AppState) =>
  state.syncCategories.categoryLatestSync;

export const selectIsCategoryPreviouslySynced = (state: AppState) =>
  !!state.syncCategories.categoryLatestSync?.syncJobId;
